import * as React from 'react';
import { PropsWithChildren } from 'react';

import { use$ } from '@legendapp/state/react';
import styled from 'styled-components';

import TrimlineDropDownContainer from '../trimline-selection/trimine-dropdown-container';

import { disclaimerStore, rootStore } from '../../store';
import { testId } from '../../test-utils/constants';
import BadgeCta from './reference-badge';

const Header = ({}: PropsWithChildren) => {
	const disclaimerId = use$(disclaimerStore.disclaimerId);

	const [_, currentModelValue] = use$(rootStore.currentModel);
	const trimName = currentModelValue.vehicleConfiguration?.trimName || '$$MISSING_TRANSLATION_KEY$$';

	return (
		<HeaderWrapper id={testId('Header_Wrapper')} data-testid={testId('Header_Wrapper')}>
			<BadgeCta />
			<div id={disclaimerId} />
			<TrimlineDropDownContainer testId={testId('Trimline_Selection_Dropdown')} title={trimName} />
		</HeaderWrapper>
	);
};

Header.displayName = 'Header';

const HeaderWrapper = styled.div`
	grid-area: header;
	display: flex;
	// We reverse order so disclaimer is first in layout but second in visual
	flex-direction: row-reverse;
	// Justify flex-end since we have row-reverse for a11y
	justify-content: flex-end;

	margin-left: ${({ theme }) =>
		theme.variant === 'v26'
			? theme.size.static300
			: theme.direction === 'ltr'
				? theme.size.static250
				: theme.size.static150};
	margin-right: ${({ theme }) => (theme.direction === 'ltr' ? theme.size.static150 : theme.size.static250)};

	user-select: none;
`;

export default Header;
